import React, { CSSProperties, FC } from "react";
import avatar from "data/avatars/avatar.jpg";
import banner from "images/placeholder-large-h.png";

interface Props extends Partial<Omit<HTMLImageElement, "style">> {
  fill?: boolean;
  style?: CSSProperties;
  onLoadingComplete?: () => void;
  isAvatar?: boolean;
}

const Image: FC<Props> = ({
  fill = false,
  className,
  alt = "",
  style,
  onLoadingComplete,
  isAvatar = false,
  ...args
}) => {
  return (
    //   @ts-ignore
    <img
      {...args}
      className={
        className + (fill ? " object-cover absolute inset-0 w-full h-full" : "")
      }
      alt={alt}
      style={style}
      onLoad={onLoadingComplete}
      onError={(e) => (e.currentTarget.src = isAvatar ? avatar : banner)} 
    />
  );
};

export default Image;
